export default {
  data: () => ({
    translations: {
      title: {
        el: 'Κατάλογος',
        en: 'Catalog',
        it: 'Catalogo',
      },
      description: {
        el: 'Περιγραφή',
        en: 'Description',
        it: 'Descrizione',
      },
      info: {
        el: 'Δημιουργήστε τον κατάλογο δώρων για το σύστημα επιβράβευσης. Ο κατάλογος δώρων σας θα περιλαμβάνει τα δώρα που θα προσθέσετε εδώ και τα κουπόνια από τα καταστήματά σας.',
        en: `
                    Create your gift catalog for your loyalty system. Your gift catalog will 
                    include the gifts you will add here and the coupons from your stores.
                `,
        it: 'Crea la lista dei regali per il sistema di ricompensa. La tua lista dei regali includerà i regali che aggiungi qui e i coupon dei tuoi negozi.',
      },
      addGift: {
        el: 'Προσθήκη Δώρου',
        en: 'Add Gift',
        it: 'Aggiungere un regalo',
      },
      createSupplier: {
        el: 'Προσθήκη Προμηθευτή',
        en: 'Create Supplier',
        it: 'Aggiungere un fornitore',
      },
      code: {
        el: 'Κωδικός Προϊόντος',
        en: 'Product Code',
        it: 'Codice prodotto',
      },
      cost: {
        el: 'Αξία',
        en: 'Value',
        it: 'Costo',
      },
      catalogCode: {
        el: 'Κωδικός Καταλόγου',
        en: 'Catalogue Code',
        it: 'Codice catalogo',
      },
      giftCode: {
        el: 'Κωδικός Δώρου',
        en: 'Gift Code',
        it: 'Codice regalo',
      },
      giftType: {
        el: 'Τύπος Δώρου',
        en: 'Gift Type',
        it: 'Tipo di regalo',
      },
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      supplier: {
        el: 'Προμηθευτής',
        en: 'Supplier',
        it: 'Fornitore',
      },
      category: {
        el: 'Κατηγορία',
        en: 'Category',
        it: 'Categoria',
      },
      giftCategory: {
        el: 'Κατηγορία Δώρου',
        en: 'Gift Category',
        it: 'Categoria regalo',
      },
      giftPrice: {
        el: 'Αξία Δώρου',
        en: 'Gift Value',
        it: 'Valore del Regalo',
      },
      giftImage: {
        el: 'Εικόνα Δώρου',
        en: 'Gift Image',
        it: 'Immagine del regalo',
      },
      lastUploaded: {
        el: 'Τελευταία μεταφόρτωση',
        en: 'Last Uploaded',
        it: 'Ultimo caricamento',
      },
      showGift: {
        el: 'Προβολή δώρου στον κατάλογο',
        en: 'Show this gift in the catalogue',
        it: 'Vedi regalo nel catalogo',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      gift: {
        el: 'Δώρο',
        en: 'Gift',
        it: 'Regalo',
      },
      type: {
        el: 'Τύπος',
        en: 'Type',
        it: 'Tipo',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      noDate: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'Aggiornamento',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      visibleToCustomer: {
        el: 'Ορατό στον πελάτη',
        en: 'Visible to customer',
        it: 'Visibile al cliente',
      },
      couponId: {
        el: 'ID Κουπονιού',
        en: 'Coupon ID',
        it: 'ID coupon',
      },
      newGiftTitle: {
        el: 'Προσθήκη Δώρου',
        en: 'Add Gift ',
        it: 'Aggiungere un regalo',
      },
      updateGiftTitle: {
        el: 'Ενημέρωση στοιχείων δώρου',
        en: 'Update gift details',
        it: 'Aggiorna i dettagli del regalo',
      },
      deleteModalTitle: {
        el: 'Διαγραφή Δώρου',
        en: 'Delete Gift',
        it: 'Elimina regalo',
      },
      deleteModalText: {
        el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το δώρο  ',
        en: 'Are you sure you want to delete ',
        it: 'Sei sicuro di voler eliminare ',
      },
      redeemAllStores: {
        el: 'Δυνατότητα εξαργύρωσης σε όλα τα καταστήματα',
        en: 'Voucher can be redeemed at all stores',
        it: 'Il buono può essere riscosso in tutti i negozi ',
      },
      redeemSpecificStores: {
        el: 'Δυνατότητα εξαργύρωσης σε συγκεκριμένα καταστήματα:',
        en: 'Voucher can be redeemed at specific stores:',
        it: 'Il buono può essere riscattato in negozi specifici:',
      },
      redeemStores: {
        el: 'Επιλέξτε καταστήματα εξαργύρωσης',
        en: 'Select redemption stores',
        it: 'Seleziona i negozi di riscatto',
      },
      visibleOnRedeemedStores: {
        el: 'Εμφάνιση στα καταστήματα εξαργύρωσης (Platform και POS)',
        en: 'Visible on redemption stores (Platform and POS)',
        it: 'Visibile nei negozi di riscatto (Platform e POS)',
      },
      visibleOnUserApps: {
        el: 'Εμφάνιση στις εφαρμογές των χρηστών (Mobile, Web)',
        en: 'Visible on user apps (Mobile, Web)',
        it: 'Visibile sulle app utente (Mobile, Web)',
      },
      chooseSynergyStores: {
        el: 'Επιλέξτε καταστήματα συνεργατών',
        en: 'Select synergy stores',
        it: 'Seleziona i negozi sinergici',
      },
      allStoresAreSelected: {
        el: 'Όλα τα καταστήματα',
        en: 'All stores are selected',
        it: 'Tutti i negozi sono selezionati',
      },
      storesSelected: {
        el: 'Επιλεγμένα καταστήματα',
        en: 'Stores selected',
        it: 'Negozi selezionati',
      },
      synergies: {
        el: 'Συνέργειες',
        en: 'Synergies',
        it: 'Sinergici',
      },
      hasSynergies: {
        el: 'Δυνατότητα εξαργύρωσης δώρου σε Συνεργάτες',
        en: 'This gift is redeemable to collaborators',
        it: 'Questo regalo è riscattabile per i collaboratori',
      },
      selectAll: {
        el: 'Επιλογή Όλων',
        en: 'Select All',
        it: 'Selezionare tutti',
      },
      diselectAll: {
        el: 'Αφαίρεση Όλων',
        en: 'Diselect all',
        it: 'Diselezionare tutti',
      },
      tierSwitchDescription: {
        el: 'Το δώρο θα είναι διαθέσιμο μόνο στους πελάτες των επιλεγμένων επιπέδων.',
        en: 'Gift will be available only customers in selected tiers.',
        it: 'I regali saranno disponibili solo per i clienti dei livelli selezionati.',
      },
      selectTiers: {
        el: 'Επιλέξτε Επίπεδα',
        en: 'Select Tiers',
        it: 'Seleziona i livelli',
      },
      amount: {
        el: 'ποσό',
        en: 'amount',
        it: 'importo',
      },
      percentage: {
        el: 'ποσοστό',
        en: 'percentage',
        it: 'percentuale',
      },
      loyalties: {
        el: 'Προγράμματα Πιστότητας',
        en: 'Loyalty Programs',
        it: 'Programmi di fidelizzazione',
      },
      loyaltiesSelected: {
        el: 'Επιλεγμένα Προγράμματα Πιστότητας',
        en: 'Selected Loyalty Programs',
        it: 'Programmi di fidelizzazione selezionati',
      },

      loadMore: {
        el: 'Φόρτωση περισσότερων...',
        en: 'Loading More...',
        it: 'Per saperne di più...',
      },
      customSmsSwitch: {
        el: 'Ενεργοποίηση προσαρμοσμένου SMS κουπονιού',
        en: 'Enable custom coupon SMS',
        it: 'Abilita SMS coupon personalizzato',
      },
      customSmsMessage: {
        el: 'Κείμενο SMS',
        en: 'SMS Text',
        it: 'Testo SMS',
      },
      customSmsInfo: {
        el: 'Εισάγετε το κείμενο που θέλετε να στέλνεται. Όπου θέλετε να συμπληρωθεί το όνομα της δωροεπιταγής εισάγετε <b>{voucher}</b>. Για τον κωδικό του voucher εισάγετε <b>{code}</b>.',
        en: `Enter the text you want to be sent. Use <b>{voucher}</b> for the voucher name and <b>{code}</b> for the voucher code.`,
        it: 'Inserisca il testo che vuole inviare. Per il nome del buono può inserire <b>{voucher}</b>. Per il codice del buono può inserire <b>{code}</b>.',
      },
      customSmsNote: {
        el: '*Παρακαλώ σημειώστε ότι ο αριθμός χαρακτήρων και το κόστος ανά SMS μπορεί να μεταβληθεί αν χρησιμοποιηθεί <b>{voucher}</b> ή <b>{code}</b>. Ο κωδικός κουπονιού <b>{code}</b> θα αποτελείται από τουλάχιστον 12 χαρακτήρες στο τελικό μήνυμα.',
        en: `*Please note that the number of characters and the cost per sms is variable if <b>{voucher}</b> or <b>{code}</b> is used. The voucher code <b>{code}</b> will consist of at least 12 characters in the final message.`,
        it: '*Si prega di notare che il numero di caratteri e il costo per SMS può variare se viene utilizzato <b>{voucher}</b> o <b>{code}</b>. Il codice voucher <b>{code}</b> consisterà di almeno 12 caratteri nel messaggio finale.',
      },
      external: {
        el: 'Εξωτερικό',
        en: 'External',
        it: 'Esterno',
      },
      uploadVouchers: {
        el: 'Ανέβασμα κουπονιών (CSV)',
        en: 'Upload vouchers (CSV)',
        it: 'Carica voucher (CSV)',
      },
      uploadCsvLabel: {
        el: 'Αρχείο CSV',
        en: 'CSV file',
        it: 'File CSV',
      },
      uploadCsvButton: {
        el: 'Ανέβασμα',
        en: 'Upload',
        it: 'Carica',
      },
      uploadCsvError: {
        el: 'Αποτυχία μεταφόρτωσης',
        en: 'Upload failed',
        it: 'Caricamento non riuscito',
      },
      uploadCsvDescription: {
        el: 'Ανεβάστε ένα αρχείο CSV που περιέχει τους κωδικούς κουπονιών για αυτό το εξωτερικό voucher. Κάθε γραμμή πρέπει να περιέχει έναν κωδικό κουπονιού.',
        en: 'Upload a CSV file containing voucher codes to attach to this external voucher. Each row should contain a single voucher code.',
        it: 'Caricare un file CSV contenente i codici voucher da associare a questo voucher esterno. Ogni riga deve contenere un codice voucher.',
      },
      uploadCsvHint: {
        el: 'Μόνο αρχεία .csv. Τα μεγάλα αρχεία μπορεί να χρειαστούν περισσότερο χρόνο επεξεργασίας.',
        en: 'Only .csv files accepted. Large files may take longer to process.',
        it: "Solo file .csv. I file di grandi dimensioni potrebbero richiedere più tempo per l'elaborazione.",
      },
    },
  }),
};
